<template>
    <div>
        <v-row no-gutters>
          <v-col cols="2">
            <v-btn text icon color="primary" class="mt-1"
              :disabled='zoom == 100' @click='zoom -= 20'>
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-btn>
            <v-btn text icon color="primary" @click='zoom += 20' class="mt-1">
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="8">
            <v-pagination
              v-model="page"
              :length="numPages"
            ></v-pagination>
          </v-col>
          <v-col cols="2">
            <v-btn text icon color="primary" :href="fileUrl" target="_blank" class="float-right">
              <v-icon>mdi-file-download</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <div class='pdf-viewer-wrapper' v-dragscroll='true' :class='{"zoom-active": zoom > 100 }'>
            <div
              v-if="loadedRatio > 0 && loadedRatio < 1"
              style="background-color: green; color: white; text-align: center"
              :style="{ width: '100%' }"
            >
              {{ Math.floor(loadedRatio * 100) }}%</div>
            <pdf
              ref="pdf"
              :src="fileUrl" :page="page"
              :rotate="rotate"
              :style="{ width: zoom + '%' }"
              @progress="loadedRatio = $event"
              @error="error" @num-pages="numPages = $event" @link-clicked="page = $event">
            </pdf>
        </div>
    </div>
</template>
<script>
import pdf from 'vue-pdf';
import { dragscroll } from 'vue-dragscroll';

export default {
  directives: { dragscroll },
  components: {
    pdf,
  },
  name: 'PdfViewer',
  props: {
    /**
     * Set url of the PDF. Default: '',
     */
    fileUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      zoom: 100,
    };
  },
  methods: {
    error(err) {
      console.log(err);
    },
  },
};
</script>

<style lang='scss'>
.pdf-viewer-wrapper {
  border: 1px solid black;
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 70vh;
  &.zoom-active {
      cursor: grab;
   }
}
</style>
